/**
 * Trigger names of the transactional messages the backend provisions for
 * every workspace (password resets, invites, ...). They exist before the
 * customer sets anything up, so "has the customer created a transactional
 * message" reads must skip them.
 */
const SYSTEM_TRIGGER_NAMES = new Set([
  'password_reset',
  'team_member_invite',
  'invite_existing_user',
  'signup_verification',
  'signup_with_existing_account',
  'copilot_message',
]);

export function isSystemTransactionalMessage(message: { trigger_name?: string | null }): boolean {
  return message.trigger_name != null && SYSTEM_TRIGGER_NAMES.has(message.trigger_name);
}
